import { Flex } from "@/atoms"
import { DownKeyboardHint, UpKeyboardHint } from "@/icons"

import styles from "./FooterItem.module.scss"

export const BrowseFilterHint = () => {
  return (
    <Flex gap={4} align="center">
      <DownKeyboardHint className={styles.keyboardHint} />
      <UpKeyboardHint className={styles.keyboardHint} />
    </Flex>
  )
}
